import React, { useState } from "react";
import { Menu, X, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Navbar Container */}
      <div className="fixed top-6 left-0 right-0 z-50 flex justify-center px-4">

        {/* Gradient Border Wrapper */}
        <div className="w-full max-w-6xl rounded-full p-[1px] bg-gradient-to-b from-[#202020]/5 via-[#202020]/15 to-[#E1CAA1]/25 shadow-[0_10px_30px_rgba(0,0,0,0.55)]"
        >
          <nav className="glass-navbar flex items-center justify-between py-3 px-6 rounded-full
            border border-white/10
            bg-[#202020]/40
            backdrop-blur-[25px]
          ">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img
                src="/images/logos/beige_logo_vb.png"
                alt="BEIGE"
                className="h-8 w-auto object-contain"
              />
            </Link>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center gap-8">
              <a href="#features" className="text-sm font-medium text-white hover:text-[#ECE1CE] transition-colors">Features</a>
              <a href="#how-it-works" className="text-sm font-medium text-white hover:text-[#ECE1CE] transition-colors">How it Works</a>
              {/* <a href="#pricing" className="text-sm font-medium text-white hover:text-[#ECE1CE] transition-colors">Pricing</a> */}
              <a href="mailto:sales@beigecorporation.io" className="text-sm font-medium text-white hover:text-[#ECE1CE] transition-colors">Contact</a>
            </div>

            {/* Auth Buttons */}
            <div className="hidden md:flex items-center gap-6">
              <Link
                to="/login"
                className="text-sm font-medium text-white hover:text-[#ECE1CE] transition-colors"
              >
                Log in
              </Link>

              <Link
                to="/signup"
                className="group flex items-center gap-1 px-5 py-2 rounded-full bg-white text-black text-sm font-medium hover:bg-[#ECE1CE] transition-all"
              >
                Sign up
                <ChevronRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden p-1 text-[#ECE1CE]"
              onClick={() => setOpen(true)}
            >
              <Menu size={24} />
            </button>
          </nav>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {open && (
        <div className="fixed inset-0 bg-[#050505]/95 z-[60] flex flex-col p-6 animate-in fade-in duration-200 backdrop-blur-xl">
          <div className="flex justify-end mb-8">
            <button
              className="p-2 text-[#ECE1CE]"
              onClick={() => setOpen(false)}
            >
              <X size={24} />
            </button>
          </div>

          <div className="flex flex-col gap-6 text-2xl font-medium text-[#ECE1CE] items-center justify-center flex-1">
            <a href="#features" onClick={() => setOpen(false)} className="hover:text-white">Features</a>
            <a href="#how-it-works" onClick={() => setOpen(false)} className="hover:text-white">How it Works</a>
            <a href="#pricing" onClick={() => setOpen(false)} className="hover:text-white">Pricing</a>
            <a href="#contact" onClick={() => setOpen(false)} className="hover:text-white">Contact</a>

            <div className="w-12 h-[1px] bg-white/10 my-4"></div>

            <Link to="/login" onClick={() => setOpen(false)} className="hover:text-white text-xl">
              Log in
            </Link>

            <Link
              to="/signup"
              onClick={() => setOpen(false)}
              className="text-[#1D1D1B] bg-[#ECE1CE] px-8 py-2 rounded-full text-xl"
            >
              Sign up
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
